import camelcaseKeys from 'camelcase-keys';
import type { CamelCasedPropertiesDeep } from 'type-fest';

export type Camelized<T> = CamelCasedPropertiesDeep<T>;

export function camelize<T extends Record<string, unknown> | readonly unknown[]>(input: T): Camelized<T>;
export function camelize<T extends Record<string, unknown> | readonly unknown[]>(input: T | null | undefined): Camelized<T> | null | undefined;
export function camelize<T extends Record<string, unknown> | readonly unknown[]>(input: T | null | undefined): Camelized<T> | null | undefined {
  // Cast explícito: com `strictNullChecks` o narrowing já entrega `null | undefined`, mas sem ele
  // `input` continua `T` e o retorno não compila. O cast deixa a passagem de nulo válida nos dois.
  if (input == null) return input as null | undefined;
  return camelcaseKeys(input as never, { deep: true }) as Camelized<T>;
}
